module.exports = __webpack_public_path__ + "media/images/baner-dec-right-e5144600776ba944cf29bc7aac683e98.png";